<template>
  <div class="secondHand">
    <carousel :images="imgs"
              arrow="never">
      <div class="header_box">
        <div class="header_title"
             style="text-align: center;"><span>{{$t('secondHand.name')}}</span></div>
        <div class="header_content">{{$t('secondHand.nav_content')}}</div>
      </div>
    </carousel>
    <div class="fixed_width">
      <div class="content_title">{{$t('secondHand.subTitle1')}}</div>
      <template v-if="!mobileDevice">
        <img v-if="lang === 'zh'"
             class="image1"
             src="@/assets/images/secondHand1.png">
        <img v-if="lang === 'en'"
             class="image1"
             src="@/assets/images/secondHand1_en.png">
      </template>
      <template v-if="mobileDevice">
        <img v-if="lang === 'zh'"
             class="image1"
             src="@/assets/images/secondHand1_mobile.png">
        <img v-if="lang === 'en'"
             class="image1"
             src="@/assets/images/secondHand1_mobile_en.png">
      </template>
    </div>
    <div style="width: 100%; background: #F9F9F9; padding: 1px 0px;">
      <div class="fixed_width">
        <div class="content_title">{{$t('secondHand.subTitle2')}}</div>
        <template v-if="!mobileDevice">
          <img v-if="lang === 'zh'"
               class="image2"
               src="@/assets/images/secondHand2.png">
          <img v-if="lang === 'en'"
               class="image2"
               src="@/assets/images/secondHand2_en.png">
        </template>
        <template v-if="mobileDevice">
          <img v-if="lang === 'zh'"
               class="image2"
               src="@/assets/images/secondHand2_mobile.png">
          <img v-if="lang === 'en'"
               class="image2"
               src="@/assets/images/secondHand2_mobile_en.png">
        </template>

        <!-- <el-row type="flex"
                align="middle">
          <el-col :xs="0"
                  :sm="12"
                  style="padding: 0rem 0.6rem;">
            <img class="image2"
                 src="@/assets/images/secondHand2.png">
          </el-col>
          <el-col :xs="24"
                  :sm="12">
            <div class="box">
              <div class="box_container">
                <div class="index">01</div>
                <div class="title">{{$t('secondHand.part2_box1_title')}}</div>
                <div class="content">
                  <div class="point_block">{{$t('secondHand.part2_box1_content1')}}</div>
                  <div class="point_block">{{$t('secondHand.part2_box1_content2')}}</div>
                  <div class="point_block">{{$t('secondHand.part2_box1_content3')}}</div>
                  <div class="point_block">{{$t('secondHand.part2_box1_content4')}}</div>
                  <div class="point_block">{{$t('secondHand.part2_box1_content5')}}</div>
                </div>
              </div>
              <div class="box_container">
                <div class="index">02</div>
                <div class="title">{{$t('secondHand.part2_box2_title')}}</div>
                <div class="content">
                  <div class="point_block">{{$t('secondHand.part2_box2_content1')}}</div>
                  <div class="point_block">{{$t('secondHand.part2_box2_content2')}}</div>
                  <div class="point_block">{{$t('secondHand.part2_box2_content3')}}</div>
                </div>
              </div>
              <div class="box_container">
                <div class="index">03</div>
                <div class="title">{{$t('secondHand.part2_box3_title')}}</div>
                <div class="content">
                  <div class="point_block">{{$t('secondHand.part2_box3_content1')}}</div>
                  <div class="point_block">{{$t('secondHand.part2_box3_content2')}}</div>
                  <div class="point_block">{{$t('secondHand.part2_box3_content3')}}</div>
                  <div class="point_block">{{$t('secondHand.part2_box3_content4')}}</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row> -->
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from '@/components/carousel'
import headerImg from '@/assets/images/secondHand_header.png'

export default {
  components: {
    Carousel
  },
  computed: {
    mobileDevice: {
      get() {
        return this.$store.state.mobileDevice
      }
    },
    lang() {
      return this.$store.state.lang
    }
  },
  data() {
    return {
      imgs: [headerImg]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/header_box.scss";
@import "../../style/content_title.scss";
@import "../../style/fixed_width.scss";
.secondHand {
  .image1 {
    width: 12rem;
    max-width: 90%;
  }

  .image2 {
    width: 12rem;
    max-width: 90%;
  }

  .box {
    text-align: left;
    .box_container + .box_container {
      border-top: 1px solid #ebebeb;
    }

    .box_container {
      padding: 0.45rem 0rem 0.25rem 0.6rem;
      margin-right: 1rem;
      position: relative;
      .index {
        position: absolute;
        top: 0.2rem;
        left: 0rem;
        font-size: 0.45rem;
        font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont,
          "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
          "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji",
          "Segoe UI Emoji", "Segoe UI Symbol";
        font-weight: 500;
        color: rgba(243, 243, 243, 1);
        line-height: 0.58rem;
      }
      .title {
        font-size: 0.24rem;
        font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont,
          "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
          "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji",
          "Segoe UI Emoji", "Segoe UI Symbol";
        font-weight: 500;
        color: rgba(27, 27, 27, 1);
        line-height: 0.36rem;
      }
      .point_block {
        display: inline-block;
        margin-left: 0.2rem;
        font-size: 0.16rem;
        font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont,
          "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
          "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji",
          "Segoe UI Emoji", "Segoe UI Symbol";
        font-weight: 400;
        color: rgba(156, 156, 156, 1);
        line-height: 0.22rem;
        position: relative;
        &:after {
          content: "";
          position: absolute;
          left: -0.15rem;
          top: 20%;
          // transform: translateY(-50%);
          margin: 0.03rem;
          width: 0.06rem;
          height: 0.06rem;
          background: #b5e0ff;
          border-radius: 50%;
        }
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .box_container {
      margin: 0 0.67rem;
    }
  }
}
</style>
